import styled from "styled-components";
import { ToastContainer } from "react-toastify";

export const StyledToastContainer = styled(ToastContainer)`
  &&&.Toastify__toast-container {
    max-width: 350px;
    width: auto;
  }
  .Toastify__toast {
    background-color: #fff;
  }
  .Toastify__toast--success {
    color: #00ff7f;
  }
  .Toastify__toast--error {
    color: #f00;
  }
  button[aria-label="close"] {
    display: none;
  }
`;
